export const lang = process.env.REACT_APP_LANG;
export const name = process.env.REACT_APP_NAME;
export const authURL = process.env.REACT_APP_AUTH_URL;
export const apiURL = process.env.REACT_APP_API_URL;
export const smsUrl = process.env.REACT_APP_SMS_URL;
export const imageUrl = process.env.REACT_APP_IMAGE_URL;
export const secretKey = process.env.REACT_APP_KEY || 'example key';
